// extracted by mini-css-extract-plugin
export default {"root":"Archive_root__IDhWm"};